import { WarningIcon } from '@treneo/shared/icons';

import { Alert } from './alert';

type Props = {
  text?: string;
  children?: React.ReactNode;
};

export const AlertWarning = ({ text, children }: Readonly<Props>) => (
  <Alert severity='warning' icon={<WarningIcon />}>
    {children ?? text}
  </Alert>
);
